{
  "version": "1.0.0",
  "captured_at": "2026-05-10T20:55:08.779899+00:00",
  "sources": {
    "live_docs_url": "https://docs.esimvault.cloud/ocs-api",
    "server_source_repo": "auroracapital/esimmcp.com",
    "server_source_commit": "8793971",
    "server_source_branch": "feat/intelligence-tools@e200c42 merged to main via restore-mcp-to-main PR#31",
    "notes": "Live docs SPA rendered via Kapture (2026-05-10). Server is a strict subset of live docs (43/52 methods). Zero server→live drift confirmed. 9 live-only methods are v1.1 backlog."
  },
  "v1_methods": [
    {
      "name": "list_reseller_accounts",
      "ocs_method": "listResellerAccount",
      "category": "reseller",
      "scope": "read",
      "description": "List all accounts across all resellers",
      "params": {
        "resellerId": { "type": "number", "required": false }
      },
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "get_reseller_info",
      "ocs_method": "getResellerInfo",
      "category": "reseller",
      "scope": "read",
      "description": "Retrieve reseller details",
      "params": {
        "resellerId": { "type": "number", "required": false, "ocs_field": "id" }
      },
      "params_note": "`resellerId` is the MCP-facing name. OCS getResellerInfo accepts exactly one property, `id`; @carrier/ocs-client translates it at the serialisation chokepoint (OCS_PARAM_RENAMES).",
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "esim_status_per_account",
      "ocs_method": "esimStatusPerAccount",
      "category": "reseller",
      "scope": "read",
      "description": "eSIM status breakdown per account",
      "params": {
        "accountId": { "type": "number", "required": false }
      },
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "list_sponsors",
      "ocs_method": "listSponsor",
      "category": "reseller",
      "scope": "read",
      "description": "List all sponsor networks",
      "params": {},
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "list_steering_lists",
      "ocs_method": "listSteeringList",
      "category": "reseller",
      "scope": "read",
      "description": "List all network steering lists",
      "params": {},
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_account_balance",
      "ocs_method": "modifyAccountBalance",
      "category": "reseller",
      "scope": "admin",
      "description": "Adjust or set reseller account balance",
      "params": {
        "accountId": { "type": "number", "required": true },
        "amount": { "type": "number", "required": true },
        "mode": { "type": "enum[adapt,set]", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "get_subscriber",
      "ocs_method": "getSingleSubscriber",
      "category": "subscriber",
      "scope": "read",
      "description": "Get full subscriber details by ICCID or MSISDN",
      "params": {
        "iccid": { "type": "string", "required": false },
        "msisdn": { "type": "string", "required": false },
        "with_gz_counter": { "type": "boolean", "required": false, "ocs_field": "withGzCounter", "description": "When true, include greenZoneCounter { subscriberId, volumeOnGZ (bytes), lastResetDate, lastUpdateDate } in response" }
      },
      "response": {
        "greenZoneCounter": { "type": "object", "present_when": "with_gz_counter=true", "fields": { "subscriberId": "number", "volumeOnGZ": "number (bytes)", "lastResetDate": "string (ISO8601)", "lastUpdateDate": "string (ISO8601)" } }
      },
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "list_subscribers",
      "ocs_method": "listSubscriber",
      "category": "subscriber",
      "scope": "read",
      "description": "List subscribers with optional filters",
      "params": {
        "accountId": { "type": "number", "required": false },
        "status": { "type": "string", "required": false },
        "offset": { "type": "number", "required": false },
        "limit": { "type": "number", "required": false }
      },
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_subscriber_balance",
      "ocs_method": "modifySubscriberBalance",
      "category": "subscriber",
      "scope": "write",
      "description": "Adjust or set subscriber balance",
      "params": {
        "iccid": { "type": "string", "required": true },
        "amount": { "type": "number", "required": true },
        "mode": { "type": "enum[adapt,set]", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_subscriber_status",
      "ocs_method": "modifySubscriberStatus",
      "category": "subscriber",
      "scope": "write",
      "description": "Change subscriber OCS status",
      "params": {
        "iccid": { "type": "string", "required": true },
        "status": { "type": "string", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "change_sim_status",
      "ocs_method": "changeSimStatus",
      "category": "subscriber",
      "scope": "write",
      "description": "Change SIM status at provider level",
      "params": {
        "iccid": { "type": "string", "required": true },
        "simStatus": { "type": "string", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "get_sim_provider_status",
      "ocs_method": "getSimProviderStatus",
      "category": "subscriber",
      "scope": "read",
      "description": "Check SIM provider-level status",
      "params": {
        "iccid": { "type": "string", "required": true }
      },
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "get_subscriber_location",
      "ocs_method": "getSubscriberLocation",
      "category": "subscriber",
      "scope": "read",
      "description": "Get last known subscriber location",
      "params": {
        "iccid": { "type": "string", "required": true }
      },
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_subscriber_contact_info",
      "ocs_method": "modifySubscriberContactInfo",
      "category": "subscriber",
      "scope": "write",
      "description": "Update subscriber contact info",
      "params": {
        "iccid": { "type": "string", "required": true },
        "firstName": { "type": "string", "required": false },
        "lastName": { "type": "string", "required": false },
        "email": { "type": "string", "required": false },
        "phoneNumber": { "type": "string", "required": false }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "set_subscriber_traffic_restrictions",
      "ocs_method": "setSubscriberTrafficRestrictions",
      "category": "subscriber",
      "scope": "write",
      "description": "Configure traffic restrictions for a subscriber",
      "params": {
        "iccid": { "type": "string", "required": true },
        "restrictions": { "type": "string(JSON)", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_subscriber_steering_list",
      "ocs_method": "modifySubscriberSteeringList",
      "category": "subscriber",
      "scope": "write",
      "description": "Change network steering list for a subscriber",
      "params": {
        "iccid": { "type": "string", "required": true },
        "steeringListId": { "type": "number", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "move_subscriber_range_to_account",
      "ocs_method": "moveSubscriberRangeToAccount",
      "category": "subscriber",
      "scope": "admin",
      "description": "Move subscriber range to another account",
      "params": {
        "iccidFrom": { "type": "string", "required": true },
        "iccidTo": { "type": "string", "required": true },
        "accountId": { "type": "number", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "hlr_set_bitrate",
      "ocs_method": "hlrSetBitrate",
      "category": "subscriber",
      "scope": "write",
      "description": "Set HLR bitrate for a subscriber",
      "params": {
        "iccid": { "type": "string", "required": true },
        "bitrate": { "type": "number", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "hlr_get_bitrate",
      "ocs_method": "hlrGetBitrate",
      "category": "subscriber",
      "scope": "read",
      "description": "Get HLR bitrate for a subscriber",
      "params": {
        "iccid": { "type": "string", "required": true }
      },
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "list_subscriber_packages",
      "ocs_method": "listSubscriberPrepaidPackages",
      "category": "packages",
      "scope": "read",
      "description": "List all prepaid packages assigned to a subscriber",
      "params": {
        "iccid": { "type": "string", "required": true }
      },
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "assign_package",
      "ocs_method": "affectPackageToSubscriber",
      "category": "packages",
      "scope": "write",
      "description": "Assign prepaid package template to subscriber",
      "params": {
        "iccid": { "type": "string", "required": true },
        "packageTemplateId": { "type": "number", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "assign_recurring_package",
      "ocs_method": "affectRecurringPackageToSubscriber",
      "category": "packages",
      "scope": "write",
      "description": "Assign recurring prepaid package to subscriber",
      "params": {
        "iccid": { "type": "string", "required": true },
        "packageTemplateId": { "type": "number", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_package_limits",
      "ocs_method": "modifySubscriberPrepaidPackageLimits",
      "category": "packages",
      "scope": "write",
      "description": "Change data/voice/SMS limits on active package",
      "params": {
        "iccid": { "type": "string", "required": true },
        "packageId": { "type": "number", "required": true },
        "limits": { "type": "string(JSON)", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_package_expiry",
      "ocs_method": "modifySubscriberPrepaidPackageExpDate",
      "category": "packages",
      "scope": "write",
      "description": "Change expiration date of active package",
      "params": {
        "iccid": { "type": "string", "required": true },
        "packageId": { "type": "number", "required": true },
        "expirationDate": { "type": "string(ISO8601)", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_package_status",
      "ocs_method": "modifySubscriberPrepaidPackageStatus",
      "category": "packages",
      "scope": "write",
      "description": "Activate or deactivate a subscriber package",
      "params": {
        "iccid": { "type": "string", "required": true },
        "packageId": { "type": "number", "required": true },
        "status": { "type": "string", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "stop_resume_recurring_package",
      "ocs_method": "stopResumeSubsRecurringPackage",
      "category": "packages",
      "scope": "write",
      "description": "Stop or resume recurring package auto-renewal",
      "params": {
        "iccid": { "type": "string", "required": true },
        "packageId": { "type": "number", "required": true },
        "action": { "type": "enum[stop,resume]", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "delete_subscriber_package",
      "ocs_method": "deleteSubscriberPackage",
      "category": "packages",
      "scope": "admin",
      "description": "Remove a package from a subscriber",
      "params": {
        "iccid": { "type": "string", "required": true },
        "packageId": { "type": "number", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "clean_all_packages",
      "ocs_method": "cleanSubscriberAllPackages",
      "category": "packages",
      "scope": "admin",
      "description": "Remove ALL packages from a subscriber",
      "params": {
        "iccid": { "type": "string", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "list_package_templates",
      "ocs_method": "listPrepaidPackageTemplate",
      "category": "templates",
      "scope": "read",
      "description": "List all prepaid package templates",
      "params": {},
      "params_note": "No account filter. OCS listPrepaidPackageTemplate accepts only locationZoneId, templateId, destinationListId, resellerId, sponsorId. The former `accountId` param was rejected by OCS on every call and is not a rename of any of those five: accounts are a different id space from resellers and sponsors.",
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "create_package_template",
      "ocs_method": "createPrepaidPackageTemplate",
      "category": "templates",
      "scope": "admin",
      "description": "Create a new prepaid package template",
      "params": {
        "template": { "type": "string(JSON)", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_template_core",
      "ocs_method": "modifyPPTCore",
      "category": "templates",
      "scope": "admin",
      "description": "Modify core settings of a package template",
      "params": {
        "templateId": { "type": "number", "required": true },
        "changes": { "type": "string(JSON)", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_template_recurring",
      "ocs_method": "modifyPPTRecurring",
      "category": "templates",
      "scope": "admin",
      "description": "Modify recurring settings of a package template",
      "params": {
        "templateId": { "type": "number", "required": true },
        "changes": { "type": "string(JSON)", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_template_throttling",
      "ocs_method": "modifyPPTThrottling",
      "category": "templates",
      "scope": "admin",
      "description": "Modify throttling settings of a package template",
      "params": {
        "templateId": { "type": "number", "required": true },
        "changes": { "type": "string(JSON)", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "list_location_zones",
      "ocs_method": "listLocationZoneElement",
      "category": "templates",
      "scope": "read",
      "description": "List countries/networks in a location zone",
      "params": {
        "locationZoneId": { "type": "number", "required": false }
      },
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "list_detailed_location_zones",
      "ocs_method": "listDetailedLocationZone",
      "category": "templates",
      "scope": "read",
      "description": "Get detailed location zone definitions",
      "params": {},
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "list_destination_prefixes",
      "ocs_method": "listDestinationListPrefix",
      "category": "templates",
      "scope": "read",
      "description": "List phone number prefixes in destination lists",
      "params": {
        "destinationListId": { "type": "number", "required": false }
      },
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "create_location_zone",
      "ocs_method": "createLocationZone",
      "category": "templates",
      "scope": "admin",
      "description": "Create a new location zone",
      "params": {
        "zone": { "type": "string(JSON)", "required": true }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "subscriber_usage",
      "ocs_method": "subscriberUsageOverPeriod",
      "category": "statistics",
      "scope": "read",
      "description": "Get daily usage for a subscriber (max 7 days)",
      "params": {
        "iccid": { "type": "string", "required": true },
        "startDate": { "type": "string(YYYY-MM-DD)", "required": true },
        "endDate": { "type": "string(YYYY-MM-DD)", "required": true }
      },
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "subscriber_network_events",
      "ocs_method": "subscriberNetworkEventsOverPeriod",
      "category": "statistics",
      "scope": "read",
      "description": "Get network events for a subscriber (max 7 days)",
      "params": {
        "iccid": { "type": "string", "required": true },
        "startDate": { "type": "string(YYYY-MM-DD)", "required": true },
        "endDate": { "type": "string(YYYY-MM-DD)", "required": true }
      },
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "subscriber_active_period",
      "ocs_method": "getSubscriberActivePeriod",
      "category": "statistics",
      "scope": "read",
      "description": "Get subscriber active period",
      "params": {
        "iccid": { "type": "string", "required": true }
      },
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "get_tariff",
      "ocs_method": "getCustomerTariff",
      "category": "tariff",
      "scope": "read",
      "description": "Retrieve customer tariff/pricing table",
      "params": {},
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "send_sms",
      "ocs_method": "sendMtSms",
      "category": "messaging",
      "scope": "write",
      "description": "Send MT SMS to a subscriber",
      "params": {
        "iccid": { "type": "string", "required": true },
        "msisdn": { "type": "string", "required": true },
        "message": { "type": "string", "required": true },
        "sender": { "type": "string", "required": false }
      },
      "response": {},
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "list_network_profiles",
      "ocs_method": "listNetworkProfile",
      "category": "network",
      "scope": "read",
      "description": "List all available network profiles",
      "params": {},
      "response": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    }
  ],
  "v1_intelligence_methods": [
    {
      "name": "diagnose_subscriber",
      "category": "intelligence",
      "scope": "read",
      "description": "AI diagnostic: chains 5 OCS calls to diagnose connectivity issues",
      "wraps": ["getSingleSubscriber", "getSimProviderStatus", "listSubscriberPrepaidPackages", "subscriberNetworkEventsOverPeriod", "hlrGetBitrate"],
      "params": {
        "iccid": { "type": "string", "required": true },
        "startDate": { "type": "string(YYYY-MM-DD)", "required": false },
        "endDate": { "type": "string(YYYY-MM-DD)", "required": false }
      },
      "verified_against_server": true,
      "verified_against_live_docs": false
    },
    {
      "name": "fleet_health",
      "category": "intelligence",
      "scope": "read",
      "description": "Single-call fleet overview: accounts, eSIM counts, low-balance alerts",
      "wraps": ["listResellerAccount", "esimStatusPerAccount", "listSubscriberPrepaidPackages"],
      "params": {},
      "verified_against_server": true,
      "verified_against_live_docs": false
    },
    {
      "name": "detect_usage_anomalies",
      "category": "intelligence",
      "scope": "read",
      "description": "Detect abnormal usage patterns across subscribers",
      "wraps": ["listSubscriber", "subscriberUsageOverPeriod"],
      "params": {
        "startDate": { "type": "string(YYYY-MM-DD)", "required": true },
        "endDate": { "type": "string(YYYY-MM-DD)", "required": true },
        "accountId": { "type": "number", "required": false }
      },
      "verified_against_server": true,
      "verified_against_live_docs": false
    },
    {
      "name": "optimize_package",
      "category": "intelligence",
      "scope": "read",
      "description": "Package optimization: match subscriber usage to best template",
      "wraps": ["getSingleSubscriber", "listSubscriberPrepaidPackages", "subscriberUsageOverPeriod", "listPrepaidPackageTemplate"],
      "params": {
        "iccid": { "type": "string", "required": true },
        "startDate": { "type": "string(YYYY-MM-DD)", "required": false },
        "endDate": { "type": "string(YYYY-MM-DD)", "required": false }
      },
      "verified_against_server": true,
      "verified_against_live_docs": false
    },
    {
      "name": "churn_risk",
      "category": "intelligence",
      "scope": "read",
      "description": "Identify subscribers at risk of churn based on usage patterns",
      "wraps": ["listSubscriber", "subscriberUsageOverPeriod", "getSubscriberActivePeriod"],
      "params": {
        "startDate": { "type": "string(YYYY-MM-DD)", "required": true },
        "endDate": { "type": "string(YYYY-MM-DD)", "required": true },
        "accountId": { "type": "number", "required": false }
      },
      "verified_against_server": true,
      "verified_against_live_docs": false
    },
    {
      "name": "audit_network_coverage",
      "category": "intelligence",
      "scope": "read",
      "description": "Audit network coverage and steering effectiveness",
      "wraps": ["listDetailedLocationZone", "listSteeringList", "getSubscriberLocation"],
      "params": {
        "iccid": { "type": "string", "required": false }
      },
      "verified_against_server": true,
      "verified_against_live_docs": false
    },
    {
      "name": "marketing_intelligence",
      "category": "intelligence",
      "scope": "read",
      "description": "Marketing insights: segment analysis, upsell opportunities",
      "wraps": ["listResellerAccount", "esimStatusPerAccount", "listPrepaidPackageTemplate", "subscriberUsageOverPeriod"],
      "params": {
        "startDate": { "type": "string(YYYY-MM-DD)", "required": true },
        "endDate": { "type": "string(YYYY-MM-DD)", "required": true }
      },
      "verified_against_server": true,
      "verified_against_live_docs": false
    },
    {
      "name": "high_cost_subscribers",
      "category": "intelligence",
      "scope": "read",
      "http_method": "POST",
      "url_path": "/v1/intelligence/high-cost-subscribers",
      "description": "Identify highest-cost subscribers for cost optimization",
      "wraps": ["listSubscriber", "subscriberUsageOverPeriod", "getCustomerTariff"],
      "params": {
        "start": { "type": "string(YYYY-MM-DD)", "required": false, "default": "first day of current month" },
        "end": { "type": "string(YYYY-MM-DD)", "required": false, "default": "today" },
        "limit": { "type": "number", "required": false, "default": 20, "max": 200 }
      },
      "verified_against_server": true,
      "verified_against_live_docs": false
    },
    {
      "name": "detect_country_entry",
      "category": "intelligence",
      "scope": "read",
      "description": "Detect subscriber country entry via getSingleSubscriber networkInfo.lastMcc (one OCS call). Resolves MCC to ISO 3166-1 alpha-2 and optionally diffs against expectedCountry.",
      "wraps": ["getSingleSubscriber"],
      "params": {
        "subscriber": { "type": "object(subscriberId|imsi|iccid|msisdn|multiImsi|activationCode)", "required": true },
        "expectedCountry": { "type": "string(ISO3166-1 alpha-2)", "required": false }
      },
      "verified_against_server": true,
      "verified_against_live_docs": false
    }
  ],
  "v1_1_backlog": [
    {
      "name": "affect_subscriber_phone_number",
      "ocs_method": "affectSubscriberFakePhoneNumber / affectSubscriberRealPhoneNumber",
      "category": "subscriber",
      "scope": "write",
      "status": "implemented",
      "description": "Assign a fake or real MSISDN to a subscriber — single MCP tool wraps both OCS methods via phone_type param",
      "params": {
        "iccid": { "type": "string", "required": true },
        "phone_number": { "type": "string(E.164)", "required": true },
        "phone_type": { "type": "enum[fake,real]", "required": true }
      },
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "get_subscriber_location_by_cell_id",
      "ocs_method": "getSubscriberLocationByCellId",
      "category": "subscriber",
      "scope": "read",
      "status": "implemented",
      "description": "Resolve a cell tower tuple (radioType + MCC + MNC + LAC + optional cellId) to lat/lon via Bridge4IP GeoSense. No subscriber identifier required — caller supplies cell params directly.",
      "params": {
        "radio_type": { "type": "enum[2G,3G,4G,5G,NB-IoT]", "required": true },
        "mcc": { "type": "integer", "required": true },
        "mnc": { "type": "integer", "required": true },
        "lac": { "type": "integer", "required": true },
        "cell_id": { "type": "integer", "required": false },
        "signal_strength": { "type": "number", "required": false }
      },
      "response": {
        "latitude": { "type": "number" },
        "longitude": { "type": "number" },
        "accuracy": { "type": "integer", "notes": "median error in meters at 50% confidence" }
      },
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "list_destination_lists",
      "ocs_method": "listDetailedDestinationList",
      "category": "templates",
      "scope": "read",
      "status": "implemented",
      "description": "List all destination lists with full detail (prefix sets for voice/SMS routing control)",
      "params": {},
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_subscriber_mobile_plan",
      "ocs_method": "modifySubscriberMobilePlan",
      "category": "subscriber",
      "scope": "write",
      "status": "implemented",
      "description": "Change the mobile plan assigned to a subscriber",
      "params": {
        "iccid": { "type": "string", "required": true },
        "mobile_plan_id": { "type": "number", "required": true }
      },
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_subscriber_package_active_period",
      "ocs_method": "modifySubscriberPrepaidPackageActivePeriod",
      "category": "packages",
      "scope": "write",
      "status": "implemented",
      "description": "Change the active period (start/end dates) of a prepaid package on a subscriber",
      "params": {
        "iccid": { "type": "string", "required": true },
        "package_id": { "type": "number", "required": true },
        "start_date": { "type": "string(ISO8601)", "required": false },
        "end_date": { "type": "string(ISO8601)", "required": false }
      },
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "modify_subscriber_voip_plan",
      "ocs_method": "modifySubscriberVoipPlan",
      "category": "subscriber",
      "scope": "write",
      "status": "implemented",
      "description": "Change the VoIP plan assigned to a subscriber",
      "params": {
        "iccid": { "type": "string", "required": true },
        "voip_plan_id": { "type": "number", "required": true }
      },
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "push_steering_to_subscriber",
      "ocs_method": "pushSteeringToSubs",
      "category": "subscriber",
      "scope": "write",
      "status": "implemented",
      "description": "Push the current steering list configuration down to the subscriber's SIM — required after modifying steering to take effect",
      "params": {
        "iccid": { "type": "string", "required": true }
      },
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "reset_subscriber_gz_counter",
      "ocs_method": "resetSubsGzCounter",
      "category": "subscriber",
      "scope": "admin",
      "status": "implemented",
      "description": "Reset the Green Zone (Greenzone) volume counter for a subscriber — tracks bytes consumed on reseller whitelist after bundle depletion. Irreversible, use only for reprovisioning or billing disputes.",
      "params": {
        "iccid": { "type": "string", "required": true }
      },
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "resolve_cell_location",
      "ocs_method": "getSubscriberLocationByCellId",
      "category": "subscriber",
      "scope": "read",
      "status": "obsolete",
      "audit_pr": "feat/ocs-feature-audit",
      "audit_stub_id": "S-03",
      "description": "OBSOLETE — duplicate of implemented get_subscriber_location_by_cell_id (same OCS method + cell tuple). Do not register. Use get_subscriber_location_by_cell_id for GeoSense cell-tower resolution.",
      "params": {
        "radio_type": { "type": "enum[2G,3G,4G,5G,NB-IoT]", "required": true },
        "mcc": { "type": "integer", "required": true },
        "mnc": { "type": "integer", "required": true },
        "lac": { "type": "integer", "required": true },
        "cell_id": { "type": "integer", "required": false },
        "signal_strength": { "type": "integer", "required": false }
      },
      "response": {
        "latitude": { "type": "number" },
        "longitude": { "type": "number" },
        "accuracy": { "type": "integer", "notes": "median error in meters at 50% confidence" }
      },
      "annotations": "readOnlyHint",
      "superseded_by": "get_subscriber_location_by_cell_id",
      "verified_against_server": false,
      "verified_against_live_docs": true
    },
    {
      "name": "carrier_webhook_config",
      "ocs_method": "getResellerInfo",
      "category": "reseller",
      "scope": "read",
      "status": "implemented",
      "audit_pr": "feat/ocs-feature-audit",
      "audit_stub_id": "S-04",
      "description": "Read-only view of Bridge4IP webhook and relay flag state from getResellerInfo.trafficInfo. Surfaces relayLU, relayGy, relayCallSms, relayVoIP booleans + notification webhook types. Relay LU is the key flag for event-driven country-change detection (vs polling). Relay endpoint config is OCS portal UI-only.",
      "params": {
        "reseller_id": { "type": "number", "required": false }
      },
      "response": {
        "relay_lu": { "type": "boolean", "notes": "Update Location relay active — closest to country-change signal" },
        "relay_gy": { "type": "boolean", "notes": "Mobile data usage relay active" },
        "relay_voip": { "type": "boolean", "notes": "VoIP usage relay active" },
        "relay_calls_sms": { "type": "boolean", "notes": "Calls + SMS relay active" },
        "notification_webhooks": { "type": "array", "notes": "Active notification types: prepaid_usage, low_credit, esim_status, recurring_packages" }
      },
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": true
    },
    {
      "name": "list_subscriber_voip_tariff",
      "ocs_method": "listSubscriberVoipTariff",
      "category": "tariff",
      "scope": "read",
      "status": "implemented",
      "description": "List VoIP tariff definitions available to a reseller (smoke-verified OCS method; not on public docs SPA). Optional resellerId filter; omit for token owner's default catalog. Companion to list_voip_tariff_rule for rule detail.",
      "params": {
        "reseller_id": { "type": "number", "required": false }
      },
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": false,
      "verified_against_live_smoke": true,
      "notes": "Live probe 2026-07-10: only known request property is resellerId (object). Empty object accepted (code 0)."
    },
    {
      "name": "list_voip_tariff_rule",
      "ocs_method": "listVoipTariffRule",
      "category": "tariff",
      "scope": "read",
      "status": "implemented",
      "description": "List rate rules for a VoIP plan/tariff by bare integer id (smoke-verified; not on public docs SPA). OCS expects a primitive integer body (same pattern as getCustomerTariff), not an object. Use plan ids from get_reseller_info chargingInfo.voipPlan or list_subscriber_voip_tariff.",
      "params": {
        "voip_plan_id": { "type": "number", "required": true }
      },
      "annotations": "readOnlyHint",
      "verified_against_server": true,
      "verified_against_live_docs": false,
      "verified_against_live_smoke": true,
      "notes": "Live probe 2026-07-10: object body rejected (expects java.lang.Integer); unknown id → OCS 6 No VoIP plan found."
    },
    {
      "name": "change_network_profile_of_location_zone",
      "ocs_method": "changeNetworkProfileOfLocationZone",
      "category": "network",
      "scope": "write",
      "status": "implemented",
      "description": "Attach or change the network profile on an existing location zone (smoke-verified; not on public docs SPA). Required fields: locationZoneId + networkProfileId. Use list_network_profiles and list_detailed_location_zones to resolve ids.",
      "params": {
        "location_zone_id": { "type": "number", "required": true },
        "network_profile_id": { "type": "number", "required": true }
      },
      "annotations": "destructiveHint",
      "verified_against_server": true,
      "verified_against_live_docs": false,
      "verified_against_live_smoke": true,
      "notes": "Live probe 2026-07-10: known properties locationZoneId, networkProfileId; missing networkProfileId → code 2 Missing 'networkProfileId'."
    }
  ],
  "v1_app_methods": [
    {
      "name": "fleet_health_app",
      "category": "apps",
      "scope": "read",
      "description": "MCP App: Fleet Health Dashboard — rendered chart UI wrapping the fleet_health composite. Read-only, no destructive ops.",
      "min_tier": "free",
      "destructive": false,
      "ui_resource_uri": "ui://fleet-health-dashboard",
      "verified_against_server": false,
      "verified_against_live_docs": false
    },
    {
      "name": "provision_esim_wizard",
      "category": "apps",
      "scope": "write",
      "description": "MCP App: eSIM Provisioning Wizard — 3-step wizard UI. Destructive on step 3 (confirm). Pro tier minimum.",
      "min_tier": "pro",
      "destructive": true,
      "destructive_step": 3,
      "ui_resource_uri": "ui://esim-provisioning-wizard",
      "verified_against_server": false,
      "verified_against_live_docs": false
    },
    {
      "name": "balance_topup_form",
      "category": "apps",
      "scope": "admin",
      "description": "MCP App: Balance Top-up Form — single-field destructive form with dry_run preview. Enterprise only, MFA-gated.",
      "min_tier": "enterprise",
      "destructive": true,
      "mfa_gated": true,
      "ui_resource_uri": "ui://balance-topup-form",
      "verified_against_server": false,
      "verified_against_live_docs": false
    },
    {
      "name": "subscriber_investigator_app",
      "category": "apps",
      "scope": "read",
      "description": "MCP App: Subscriber Investigator — single-subscriber drill-down panel (identity, packages, usage, network events). Read-only, no destructive ops.",
      "min_tier": "free",
      "destructive": false,
      "ui_resource_uri": "ui://apps/subscriber-investigator",
      "verified_against_server": false,
      "verified_against_live_docs": false
    },
    {
      "name": "template_zone_builder_app",
      "category": "apps",
      "scope": "write",
      "description": "MCP App: Template & Zone Builder — multi-step builder for a package template or location zone, with a preview step before the confirm write. Pro tier minimum; refused for managed sessions at the OCS scope layer.",
      "min_tier": "pro",
      "destructive": true,
      "destructive_step": 4,
      "ui_resource_uri": "ui://apps/template-builder",
      "verified_against_server": false,
      "verified_against_live_docs": false
    },
    {
      "name": "action_receipt_app",
      "category": "apps",
      "scope": "write",
      "description": "MCP App: Action Receipt & Rollback Viewer — ledger of recorded write actions with verification evidence and rollback where a rollback method was recorded. Viewing/recording needs no OCS write; rollback requires write scope.",
      "min_tier": "free",
      "destructive": true,
      "ui_resource_uri": "ui://apps/action-receipt",
      "verified_against_server": false,
      "verified_against_live_docs": false
    }
  ]
}
